(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.EditContactInfoController = (function(superClass) {
    extend(EditContactInfoController, superClass);

    function EditContactInfoController(scope, transitions, modalInstance, service, contact) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.save = bind(this.save, this);
      EditContactInfoController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      if (contact.data.status.type === 'success') {
        this.scope.user = contact.data.data.user;
        this.scope.user.require_email = this.scope.user.authenticated;
        this.scope.user.require_phone = this.scope.user.phone != null;
        this.scope.states = contact.data.data.states;
      } else {
        this.scope.no_user_message = contact.data.status.msg;
      }
    }

    EditContactInfoController.prototype.save = function(pretend) {
      this.scope.user.phone = this.scope.user.phone != null ? this.scope.user.phone.replace(/[\D]+/g, '') : void 0;
      if (!pretend) {
        this.setAlert({
          type: 'success',
          msg: 'Saving...'
        });
      }
      return this.service.updateContactInfo(this.scope.user).then((function(_this) {
        return function(response) {
          if (!pretend) {
            return _this.closeWithAlert(response.data.status);
          }
        };
      })(this));
    };

    return EditContactInfoController;

  })(DialogController);

}).call(this);
